import { useState } from "react";
import Button from "@/components/Button";
import {
    Modal,
    ModalContent,
    ModalBody,
    ModalFooter,
    useDisclosure,
} from "@nextui-org/react";

import StartQuiz from "./StartQuiz";
import Loader from "@/components/Loader";

function QuizDetail({ isLocked, quizData }) {
    const [startTheQuiz, setStartTheQuiz] = useState(false);
    const { isOpen, onOpen, onOpenChange } = useDisclosure();

    const {
        attributes: { quizDuration, quizAttemptLimit },
        id,
        realSubmits,
        attemptCount,
        validQuestionsCount,
        quizAttemptsMinScorePercentage,
        quizAttemptsMaxScorePercentage,
        quizAttemptsAvgScorePercentage,
    } = quizData;

    const limit =
        quizAttemptLimit === null
            ? false
            : quizAttemptLimit > attemptCount
            ? false
            : true;

    if (!quizData) return null;

    function handleStartQuiz() {
        setStartTheQuiz(true);
    }

    return (
        <div className="px-5 py-3 border-t-2">
            <div className="relative flex w-full h-5 overflow-hidden rounded-full bg-default-200">
                <span
                    className="absolute right-0 z-20 block h-5 bg-mint-green-color-primary"
                    style={{ width: `${quizAttemptsMinScorePercentage}%` }}
                ></span>
                <span
                    className="absolute right-0 z-10 block h-5 bg-gray-color-primary"
                    style={{ width: `${quizAttemptsAvgScorePercentage}%` }}
                ></span>
                <span
                    className="absolute right-0 block h-5 bg-primary-color-primary"
                    style={{
                        width: `${quizAttemptsMaxScorePercentage}%`,
                        zIndex:
                            quizAttemptsMaxScorePercentage >
                                quizAttemptsAvgScorePercentage &&
                            quizAttemptsMaxScorePercentage >
                                quizAttemptsMinScorePercentage
                                ? "0"
                                : "80",
                    }}
                ></span>
            </div>

            <div className="py-5">
                <ul className="flex flex-wrap justify-between ">
                    <li className="flex gap-2 py-2 font-medium text-blue-color-primary">
                        <span className="block w-5 h-5 rounded-full bg-mint-green-color-primary"></span>
                        <p>أقل نتائجك:</p>
                        <span className="text-gray-color-primary">
                            {quizAttemptsMinScorePercentage
                                ? `${parseFloat(
                                      quizAttemptsMinScorePercentage
                                  ).toFixed(2)}%`
                                : "0%"}
                        </span>
                    </li>
                    <li className="flex gap-2 py-2 font-medium text-blue-color-primary">
                        <span className="block w-5 h-5 rounded-full bg-primary-color-primary"></span>
                        <p>أعلي نتائجك:</p>
                        <span className="text-gray-color-primary">
                            {quizAttemptsMaxScorePercentage
                                ? `${parseFloat(
                                      quizAttemptsMaxScorePercentage.toFixed(2)
                                  )}%`
                                : "0%"}
                        </span>
                    </li>
                    <li className="flex gap-2 py-2 font-medium text-blue-color-primary">
                        <span className="block w-5 h-5 rounded-full bg-gray-color-primary"></span>
                        <p>متوسط نتائجك:</p>
                        <span className="text-gray-color-primary">
                            {quizAttemptsAvgScorePercentage
                                ? `${parseFloat(
                                      quizAttemptsAvgScorePercentage.toFixed(2)
                                  )}%`
                                : "0%"}
                        </span>
                    </li>
                </ul>
                <ul className="flex flex-wrap gap-8 py-5 font-semibold text-blue-color-primary">
                    <li>
                        - الفرص المتاحة:
                        <span className="px-1 text-gray-color-primary">
                            {quizAttemptLimit === null
                                ? "عدد لا نهائي"
                                : quizAttemptLimit - attemptCount > 1
                                ? quizAttemptLimit - attemptCount
                                : 0}
                        </span>
                    </li>
                    <li>
                        - عدد مرات دخول الأمتحان :
                        <span className="px-1 text-gray-color-primary">
                            {attemptCount}
                        </span>
                    </li>
                    <li>
                        - عدد مرات انهائك للأمتحان :
                        <span className="px-1 text-gray-color-primary">
                            {realSubmits}
                        </span>
                    </li>
                    <li>
                        - عدد الأسئلة :
                        <span className="px-1 text-gray-color-primary">
                            {validQuestionsCount}
                        </span>
                    </li>
                    <li>
                        - مدة الأمتحان :
                        <span className="px-1 text-gray-color-primary">
                            {" "}
                            {quizDuration} دقيقة
                        </span>
                    </li>
                </ul>
            </div>
            {!isLocked && validQuestionsCount && !limit ? (
                <Button
                    type="primary"
                    onClick={onOpen}
                    className="w-full mx-auto"
                    disabled={isLocked}
                >
                    دخول الأمتحان
                </Button>
            ) : null}
            <div>
                <Modal
                    classNames={{ base: "m-0 pb-12 md:pb-0" }}
                    isOpen={isOpen}
                    onOpenChange={onOpenChange}
                    isDismissable={!startTheQuiz}
                    closeButton={!startTheQuiz}
                    motionProps={{
                        variants: {
                            enter: {
                                scale: "var(--scale-enter)",
                                y: "var(--slide-enter)",
                                opacity: 1,
                                transition: {
                                    scale: {
                                        duration: 0.4,
                                        ease: [0.36, 0.66, 0.4, 1],
                                    },
                                    opacity: {
                                        duration: 0.4,
                                        ease: [0.36, 0.66, 0.4, 1],
                                    },
                                    y: {
                                        type: "spring",
                                        bounce: 0,
                                        duration: 0.6,
                                    },
                                },
                            },
                            exit: {
                                scale: "var(--scale-exit)",
                                y: "var(--slide-exit)",
                                opacity: 0,
                                transition: {
                                    duration: 0.3,
                                    ease: [0.36, 0.66, 0.4, 1],
                                },
                            },
                        },
                    }}
                >
                    <ModalContent>
                        {(onClose) => (
                            <>
                                <ModalBody className="flex flex-col items-center justify-center pt-5">
                                    <img
                                        src="/images/Question.webp"
                                        alt="Question mark Image"
                                        className="w-32"
                                    />
                                    <p className="text-xl font-semibold text-blue-color-primary">
                                        هل انت متأكد من انك تريد بدأ الامتحان
                                        الأن ؟
                                    </p>
                                </ModalBody>
                                <ModalFooter className="flex items-center justify-center gap-5 pb-6">
                                    {!startTheQuiz ? (
                                        <>
                                            <Button
                                                type="primary"
                                                onClick={handleStartQuiz}
                                                className="w-36"
                                                disabled={isLocked}
                                            >
                                                بدأ الأمتحان
                                            </Button>
                                            <Button
                                                type="customized"
                                                onClick={onClose}
                                                className="px-4 py-2 text-white rounded-full bg-gray-color-light w-36 md:px-6 "
                                            >
                                                إلغاء
                                            </Button>
                                        </>
                                    ) : (
                                        <div className="flex flex-col items-center justify-center">
                                            <Loader />
                                            <p>جاري تحميل الأمتحان ...</p>
                                        </div>
                                    )}
                                </ModalFooter>
                            </>
                        )}
                    </ModalContent>
                </Modal>
            </div>
            {startTheQuiz && (
                <StartQuiz quizId={id} setStartTheQuiz={setStartTheQuiz} />
            )}
        </div>
    );
}

export default QuizDetail;
